/* Single Post.
 *
 * @file single
 *
 */
/* eslint-disable-next-line */
import styles from "../../../sass/layouts/cpt_templates/single-post.scss";

jQuery(document).ready(function($) {
    const entryContent = document.querySelector('.entry-content');
    const postContainer = document.querySelector('.single-post');

    if (entryContent && entryContent.clientHeight <= 2200) {
        postContainer.classList.add('single-post__short');
    }
});
